export default "__VITE_ASSET__BC34oHK$__"